import { User, UserRole } from '../types';
import { database } from './firebase';
import { ref, get, set, update, remove } from 'firebase/database';

const USERS_REF = 'users';

export const getUsers = async (): Promise<User[]> => {
  const usersRef = ref(database, USERS_REF);
  const snapshot = await get(usersRef);
  if (snapshot.exists()) {
    const usersObject = snapshot.val();
    return Object.values(usersObject);
  }
  return [];
};

export const saveUsers = async (users: User[]): Promise<void> => {
  const usersObject = users.reduce((acc, user) => {
    acc[user.id] = user;
    return acc;
  }, {} as { [key: string]: User });
  
  await set(ref(database, USERS_REF), usersObject);
};

export const addUser = async (user: User): Promise<void> => {
    await set(ref(database, `${USERS_REF}/${user.id}`), user);
}

export const updateUserRole = async (userId: string, role: UserRole): Promise<void> => {
    await update(ref(database, `${USERS_REF}/${userId}`), { role });
}

export const updateUserPassword = async (userId: string, password: string): Promise<void> => {
    await update(ref(database, `${USERS_REF}/${userId}`), { password });
}

export const updateUser2FA = async (userId: string, twoFactorData: { twoFactorEnabled: boolean, twoFactorSecret?: string, twoFactorRecoveryCodes?: string[] }): Promise<void> => {
    await update(ref(database, `${USERS_REF}/${userId}`), twoFactorData);
};

export const deleteUser = async (userId: string): Promise<void> => {
    await remove(ref(database, `${USERS_REF}/${userId}`));
};